module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/logo1-59316ff37de4278a68b413bed4bfb8bd.png";